module.exports = __webpack_public_path__ + "static/media/selfcare.3fc31c11.svg";